import React, { useState, useEffect } from 'react';
import userService from '../services/user';
import utils from '../utils/utils';
import { NavLink, Redirect } from "react-router-dom";
import { setKey, setStringifiedKey } from "../store/actions";
import { connect } from "react-redux";
import keys from '../store/keys';
import moment from 'moment';

function PersonalInformation({ session, setKey, setStringifiedKey, ...props }) {

    const [firstname, setFirstname] = useState(session.user.firstname);
    const [lastname, setLastname] = useState(session.user.lastname);
    const [dob, setDoB] = useState(moment(session.user.dob).format("YYYY-MM-DD"));
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [redirectTo, setRedirectTo] = useState(null);

    const handleSubmit = e => {
        e.preventDefault();
        if (!firstname || !lastname || !dob) {
            setErrorMessage(`Please provide all fields.`);
            return;
        }

        setKey(keys.isLoading, true);
        userService.updatePersonalInformation(session.token, { firstname, lastname, dob })
            .then(result => {
                if (result.error) {
                    setErrorMessage(result.error);
                    setKey(keys.isLoading, false);
                    return;
                }

                const data = result.data;
				setStringifiedKey(keys.user, data);
                setErrorMessage('');
                setSuccessMessage(`Information updated successfully!.`);
                setKey(keys.isLoading, false);
            });
    }

    return (
        <>
            {redirectTo && <Redirect push to={redirectTo} />}
            <div className="container">
                <p className="cart-title">Personal Information</p>
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col">
                            <div className="form-group">
                                <label htmlFor="txtEmail" className="form-label">
                                    <i className="fa-solid fa-envelope"></i>
                                    {session.user.email}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="form-group mb-2">
                                <label htmlFor="txtEmail" className="form-label">
                                    <i className="fa-solid fa-clock"></i>
                                    Member since: {utils.dayMonthYearFormat(session.user.dob)}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-12">
                            <div className="form-group mb-2">
                                <label htmlFor="txtFirstname" className="form-label">
                                    First name
                                </label>
                                <input
                                    className="form-control shadow-none"
                                    type="text"
                                    placeholder="John"
                                    required="required"
                                    id="txtFirstname"
                                    value={firstname}
                                    onChange={e => setFirstname(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="form-group mb-2">
                                <label htmlFor="txtLastname" className="form-label">
                                    Last name
                                </label>
                                <input
                                    className="form-control shadow-none"
                                    type="text"
                                    placeholder="Doe"
                                    required="required"
                                    id="txtLastname"
                                    value={lastname}
                                    onChange={e => setLastname(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-12">
                            <div className="form-group mb-2">
                                <label htmlFor="txtDob" className="form-label">
                                    Date of birth
                                </label>
                                <input
                                    className="form-control shadow-none"
                                    type="date"
                                    required="required"
                                    id="txtDob"
                                    value={dob}
                                    onChange={e => setDoB(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            {errorMessage && <div className="text-danger mb-2">{errorMessage}</div>}
                            {successMessage && <div className="text-success mb-2">{successMessage}</div>}
                        </div>
                    </div>
                    <div className="row text-end">
                        <div className="col">
                            <button
                                type="submit"
                                className="btn btn-dark shadow-none mt-10 mb-3"
                                onClick={handleSubmit}>
                                Save Changes
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}

const mapStateToProps = (store) => ({ session: store.session });
const mapDispatchToProps = (dispatch) => ({
    setKey: (key, value) => dispatch(setKey(key, value)),
    setStringifiedKey: (key, value) => dispatch(setStringifiedKey(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PersonalInformation);
